import { DownloadButton, downloadCsv } from '@foradevelopment/fora-ui';
import { trackCustomEvent } from '@fora-monorepo/webapp-analytics';

import { formatFileName } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';
import { useAppDispatch } from '../../redux/hooks';
import { getPayrollDetailsCSV } from '../../redux/report/reportThunks';
import { DownloadButtonProps } from './types';

// FYI this can't be used in the recipt panels of manual & file reporting since the data sources are different
export const DownloadButtonReportDetails = ({
  reportId,
  partnerNumberOrganization,
  employerName,
  createdDate,
  organizationNumber,
  fontSize,
}: DownloadButtonProps) => {
  const { t } = useTypedTranslation();
  const dispatch = useAppDispatch();

  const downloadDetailsCSV = async () => {
    const result = await dispatch(
      getPayrollDetailsCSV({ partnerNumberOrganization, reportId, reportedAtTimestamp: createdDate })
    );
    if (getPayrollDetailsCSV.fulfilled.match(result)) {
      if (result.payload?.base64EncodedFile) {
        downloadCsv(
          result.payload.base64EncodedFile,
          formatFileName({ fileType: 'report-details', createdDate, employerName, organizationNumber })
        );
        trackCustomEvent('Downloaded payroll report details CSV');
        return null;
      }
      return t('errorMessages.somethingWentWrongNoFileTryLater');
    } else {
      return t('errorMessages.somethingWentWrongWithCsvTryAgain');
    }
  };
  return (
    <DownloadButton
      name={t('list.historyLog.reportedPayrollCsvFileName')}
      download={downloadDetailsCSV}
      fontSize={fontSize}
    />
  );
};
